import React, { useState, useEffect, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import PersonIcon from '@material-ui/icons/Person';
import LoadingLayer from '@controls/LoadingLayer';
import { faLoader } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Typography, Avatar, Button, Box, Chip, Grid } from '@material-ui/core';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import * as storage from '@utils/storage';
import { IsEnglish } from '@utils/language';
import * as pageSourceCode from '@scripts/PageSourceCode';
import { getGenderBackgroundColor, getGenderColor } from '@scripts/GenderHelper';
import { getCentralApprovalStatusDescription, centralApprovalStatus } from '@scripts/CentralApprovalStatusHelper';
import { getCentralApprovalTypeDescription, getCentralApprovalTypeColor, approvalType } from '@scripts/CentralApprovalTypeHelper';
import { cancellableStatus, getCentralApprovalCancellableStatusDescription } from '@scripts/CentralApprovalCancellableStatusHelper';
import { getListApprovalCentrals, formatRange, approveRequest, denyRequest } from '@actionsSup/approvalCentral';
import { saveLeaveApprovalCentralRequest, saveShiftExchangeRequestComment } from '@actionsSup/approvalCentral';
import ScheduleGenerationForm from './ScheduleGenerationForm';
import DenyWithCommitRequestForm from './DenyWithCommitRequestForm';
import { messagesTypes } from '@utils/constants';
import { format, formatDate, isNullOrEmpty } from '@utils';
import { MessageContext } from '@/MessageProvider';
import { makeStyles } from '@material-ui/core/styles';
import styles from '@styles/approvalCentral.module.css';
import RequestDetail from './RequestDetail';

const useStyles = makeStyles((theme) => ({
    divListRequest: {
        width: '100%',
        textAlign: 'center',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    cardStyle: {
        boxShadow: '0 0 4px 1px #1616161c !important',
        borderColor: '#5555552e !important',
        margin: 'auto',
        wordWrap: 'break-word',
        border: '1px solid #cdcdcdc7 !important',
        borderRadius: '10px !important',
        marginTop: '10px !important',
        maxWidth: 'calc(100vw - 27px)',
        padding: '0px !important',
        textOverflow: 'ellipsis',
        '&:first-of-type': {
            marginTop: '0 !important'
        },
    },
    cardContentStyle: {
        padding: '10px 10px 10px 10px !important'
    },
    h6Style: {
        fontSize: '0.98rem !important'
    },
    body2Style: {
        fontSize: '0.8rem !important'
    }
}));

function ListRequestItems(props) {

    const {
        filter
    } = props;
    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);

    const [data, setData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [actionTypeCode, setActionTypeCode] = useState(null);
    const [open, setOpen] = useState(false);
    const [comment, setComment] = useState('');
    const [openCommentForm, setOpenCommentForm] = useState(null);
    const [openScheduleGeneration, setOpenScheduleGeneration] = useState(null);
    const [isConfirm, setIsConfirm] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [messageConfirm, setMessageConfirm] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const [isCancellable, setIsCancellable] = useState(false);
    const [isLeaveRequest, setIsLeaveRequest] = useState(false);
    const [isDenyButtonEnabled, setIsDenyButtonEnabled] = useState(false);
    const [isApproveButtonEnabled, setIsApproveButtonEnabled] = useState(false);

    const actionType = {
        DENY: 'R',
        APPROVE: 'F'
    }

    useEffect(() => {
        resizeForm();
    }, [])

    useEffect(() => {
        setIsActive(true);
        loadPage();
    }, [filter])

    useEffect(() => {
        if (actionTypeCode) {
            switch (actionTypeCode) {
                case actionType.APPROVE:
                    {
                        handleApproveRequest();
                        break;
                    }
                case actionType.DENY:
                    {
                        handleDenyRequest();
                        break;
                    }
            }
        }
    }, [actionTypeCode])

    useEffect(() => {
        if (openCommentForm === false) {
            setIsActive(false);
            handleCloseConfirm(true);
        }
    }, [openCommentForm])

    useEffect(() => {
        if (openScheduleGeneration === false) {
            setIsActive(false);
            handleCloseConfirm(true);
        }
    }, [openScheduleGeneration])

    const resizeForm = () => {

        if (props.resizeForm != undefined && props.resizeForm != null) {
            props.resizeForm();
            return;
        }

        setTimeout(function () {
            const offSet = 114;
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const customHeight = height - header - titleBar - offSet;
            const element = document.querySelector('#divListRequest');

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 0);
    }

    const loadPage = () => {
        if (filter != null
            && filter.typeRequest !== undefined
            && filter.typeRequest !== null) {
            loadData();
        }
    }

    const loadData = async () => {

        let typeRequest = filter.typeRequest;
        let status = filter.status;

        // default
        if (typeRequest === undefined || typeRequest === null) {
            typeRequest = [approvalType.LEAVE, approvalType.LEAVE_AZUR, approvalType.VACATION, approvalType.VACATION_AZUR];
        }

        if (status === undefined || status === null) {
            status = [centralApprovalStatus.OPENED, centralApprovalStatus.CANCEL_REQUEST];
        }

        if (typeRequest.length === 0 || status.length === 0) {
            setData(null);
            setIsActive(false);
            return;
        }

        const result = await getListApprovalCentrals(status.join('|'), typeRequest.join('|'));

        if (result !== undefined) {
            let list = await formatList(result);
            setData(list);
            setIsActive(false);
        }
    }

    const formatList = async (data) => {
        return new Promise(async (resolve) => {
            const list = [];
            data.forEach((item) => {
                item.statusDescription = getCentralApprovalStatusDescription(item.statusCode);
                list.push(item);
            });

            resolve(list);
        })
    }

    const getIsCancellable = (obj) => {
        return obj.cancellableCode == cancellableStatus.CANCELLABLE;
    }

    const getIsActionButtonShown = (obj) => {
        //return obj.statusCode == centralApprovalStatus.OPENED || obj.statusCode == centralApprovalStatus.CANCEL_REQUEST || obj.statusCode == centralApprovalStatus.CALENDAR_REQUEST;
        return true;
    }

    const getIsApproveButtonEnabled = (obj) => {
        return obj.statusCode == centralApprovalStatus.OPENED || obj.statusCode == centralApprovalStatus.CANCEL_REQUEST;
    }

    const getIsDenyButtonEnabled = (obj) => {
        return obj.statusCode == centralApprovalStatus.CLOSE ?
            getIsCancellable(obj) :
            obj.statusCode != centralApprovalStatus.CANCELED;
    }

    const getIsLeaveRequest = (obj) => {
        return (obj.approvalType === approvalType.LEAVE
            || obj.approvalType === approvalType.LEAVE_AZUR
            || obj.approvalType === approvalType.VACATION
            || obj.approvalType === approvalType.VACATION_AZUR)
            && (getIsApproveButtonEnabled(obj) || getIsDenyButtonEnabled(obj))
            && obj.statusCode == centralApprovalStatus.OPENED
            && isNullOrEmpty(obj.approverComment);
    }

    const updateAction = async () => {
        if (actionTypeCode) {
            switch (actionTypeCode) {
                case actionType.APPROVE:
                    {
                        updateApproveRequest();
                        break;
                    }
                case actionType.DENY:
                    {
                        updateDenyRequest();
                        break;
                    }
            }
        }
    }

    const approve = async (updateComment = false) => {

        setOpenConfirm(false);
        setIsActive(true);

        const result = await approveRequest(dataRow.centralApprovalId);

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsActive(false);
            return;
        } else if (result.statusCode === 0) {

            dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === 1) {

            dispatch({ type: messagesTypes.WARNING, payload: result.message });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === -2) {
            setIsActive(false);
            setOpenScheduleGeneration(true);
            return;
        }

        handleCloseConfirm(true);
        loadData();
    }

    const updateApproveRequest = async () => {
        approve(open);
    }

    const deny = async (updateComment = false) => {

        setOpenConfirm(false);
        setIsActive(true);

        const result = await denyRequest(dataRow.centralApprovalId, dataRow.approvalType, comment);

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsActive(false);
            return;
        } else if (result.statusCode === 0) {

            let messsge = i18next.t('approvalCentral:message.refusedSucess');

            if (!isLeaveRequest
                && dataRow.statusCode == centralApprovalStatus.CLOSE) {
                messsge = i18next.t('approvalCentral:message.canceledSuccess');
            }

            dispatch({ type: messagesTypes.SUCCESS, payload: messsge });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === 1) {

            dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message ?? i18next.t('approvalCentral:message.deleteError') });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === -2) {
            setIsActive(false);
            setOpenScheduleGeneration(true);
            return;
        }

        handleCloseConfirm(true);
        loadData();
    }

    const saveComment = async (showMessage = true) => {

        let result = undefined;

        if (dataRow.approvalType === approvalType.SHIFT_EXCHANGE) {
            result = await saveShiftExchangeRequestComment(dataRow.originTableNameId, comment);
        } else {
            result = await saveLeaveApprovalCentralRequest(dataRow.originTableNameId, dataRow.isToReplace, comment);
        }

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsActive(false);
            return false;
        } else if (result.statusCode === 0) {
            if (showMessage === true) {
                dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });
            }
            return true;
        } else if (result.statusCode === -1) {
            dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message });
            setIsActive(false);
            return false;
        }
    }

    const updateDenyRequest = async () => {
        deny(open);
    }

    const handleApproveRequest = () => {
        if (isApproveButtonEnabled) {
            if (isCancellable) {
                if (isNullOrEmpty(messageConfirm)) {
                    updateApproveRequest();
                } else {
                    setIsConfirm(true);
                    setOpenConfirm(true);
                }
            } else {
                setIsConfirm(false);
                setOpenConfirm(true);
            }
        } else {
            setActionTypeCode(null);
        }
    }

    const handleDenyRequest = () => {
        if (isDenyButtonEnabled) {
            if (isLeaveRequest) {
                if (storage.getIsRefusalRequestMandatoryComment()) {
                    if (!open) {
                        setOpenCommentForm(true);
                    } else {
                        if (!comment?.trim()) {
                            dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.refusalComent') });
                        } else {
                            updateDenyRequest();
                        }
                    }

                } else {
                    updateDenyRequest();
                }
            } else {
                if (isNullOrEmpty(messageConfirm)) {
                    updateDenyRequest();
                } else {
                    setIsConfirm(true);
                    setOpenConfirm(true);
                }
            }
        } else {
            setActionTypeCode(null);
        }
    }

    const handleRequest = (event, obj, action, stopPropagation = true) => {
        if (stopPropagation) {
            event.stopPropagation();
        }
        
        const isLeaveRequest = getIsLeaveRequest(obj);
        const isDenyButtonEnabled = getIsDenyButtonEnabled(obj);
        const isApproveButtonEnabled = getIsApproveButtonEnabled(obj);

        switch (action) {
            case actionType.APPROVE:
                {
                    const approveMessage = getCentralApprovalCancellableStatusDescription(obj.cancellableCode, obj.statusCode, obj.applicantName, obj.creationDate, obj.description);
                    setMessageConfirm(approveMessage);
                    break;
                }
            case actionType.DENY:
                {
                    let denyMessage = '';
                    if (!isLeaveRequest &&
                        (isApproveButtonEnabled
                            || isDenyButtonEnabled)) {
                        if (obj.statusCode == centralApprovalStatus.CLOSE) {
                            denyMessage = format(i18next.t("approvalCentral:message.cancelation.cancelApprobationConfirmation"), obj.applicantName, i18next.t("approvalCentral:message.cancelation.approbationRequestConfirmationCreatedOn"), formatDate(obj.creationDate, 'date'));
                        } else {
                            denyMessage = format(i18next.t("approvalCentral:message.cancelation.denyApprobationConfirmation"), obj.applicantName, i18next.t("approvalCentral:message.cancelation.approbationRequestConfirmationCreatedOn"), formatDate(obj.creationDate, 'date'));
                        }
                    }

                    setMessageConfirm(denyMessage);
                    break;
                }
        }

        setDataRow(obj);
        setIsCancellable(getIsCancellable(obj));
        setIsLeaveRequest(isLeaveRequest);
        setIsDenyButtonEnabled(isDenyButtonEnabled);
        setIsApproveButtonEnabled(isApproveButtonEnabled);
        setActionTypeCode(action);
    }

    const handleCloseConfirm = (ignoreLoading = false, closeDetail = true) => {

        setOpenConfirm(false);

        if (!ignoreLoading) {
            setIsActive(false);
        }

        if (closeDetail === true) {
            setOpen(false);
        }

        setActionTypeCode(null);

        if (closeDetail === true) {
            setDataRow(null);
        }
    }

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setDataRow(null);
        setOpen(false);
    };

    const CentralApprovalCard = ({ data }) => {

        const chipStyle = {
            backgroundColor: getCentralApprovalTypeColor(data.approvalType),
            color: 'dark'
        };

        let denyTitle = '';
        const isApproveButtonEnabled = getIsApproveButtonEnabled(data);
        const isDenyButtonEnabled = getIsDenyButtonEnabled(data);
        const isLeaveRequest = getIsLeaveRequest(data);
        const isActionButtonShown = getIsActionButtonShown(data);

        //if (isApproveButtonEnabled || isDenyButtonEnabled) {
        denyTitle = i18next.t('approvalCentral:button.deny');
        if (!isLeaveRequest && data.statusCode == centralApprovalStatus.CLOSE) {
            denyTitle = i18next.t('approvalCentral:button.cancel');
        }
        //}

        const iconStyle = {
            borderRadius: '50%',
            color: '#22c55e',
            backgroundColor: 'white',
            padding: '5px',
            width: '15px',
            height: '15px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        };

        return (
            <Card className={classes.cardStyle} onClick={() => handleClick(data)}>
                <CardContent className={classes.cardContentStyle}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <Avatar style={{ color: '#2563eb', backgroundColor: `#e0f2fe` }}>
                                <PersonIcon />
                            </Avatar>
                        </Grid>
                        <Grid item xs style={{ marginTop: 10, textAlign: 'left' }}>
                            <Typography className={classes.h6Style} variant="h6" component="div">
                                {data.employeeFirstName + ' ' + data.employeeLastName}
                            </Typography>
                            <Typography className={classes.body2Style} variant="body2" color="textSecondary">
                                {data.approvalType != approvalType.BANK_ACCOUNT_CHANGE && formatRange(IsEnglish(), data.startDate, data.endDate, data.request)}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Chip style={chipStyle} label={getCentralApprovalTypeDescription(data.approvalType)} color="primary" size="small" />
                        </Grid>
                    </Grid>
                    {data.statusCode == centralApprovalStatus.CANCEL_REQUEST && <Typography className={classes.body2Style} variant="body2" style={{ marginTop: 10, textAlign: 'left', backgroundColor: 'red', width: 'fit-content', color: 'white', borderRadius: '10px', paddingLeft: '6px', paddingRight: '6px', paddingTop: '3px', paddingBottom: '3px' }}>
                        {getCentralApprovalStatusDescription(data.statusCode)}
                    </Typography>}
                    {data.employeeComment && <Typography className={classes.body2Style} variant="body2" style={{ marginTop: 10, textAlign: 'left' }}>
                        {i18next.t('approvalCentral:form.reason')} {data.employeeComment}
                    </Typography>}
                    <Box display="flex" justifyContent={isActionButtonShown && !data.request.isAzur && !storage.getAllowConsultation() ? "space-between" : "right"} marginTop={2} style={{ gap: "2px" }} >
                        {isActionButtonShown && !data.request.isAzur && !storage.getAllowConsultation() && <Button startIcon={
                            <div style={iconStyle}>
                                <CheckIcon style={{ fontSize: '12px' }} />
                            </div>
                        } variant="contained" color="primary" size="small" className={`${styles.buttonStyle} ${(isActive || !isApproveButtonEnabled) ? styles.buttonDisabled : ""}`} style={{ backgroundColor: '#22c55e' }} onClick={(event) => handleRequest(event, data, actionType.APPROVE)}>
                            <span className={styles.buttonSpanStyle}>{i18next.t('approvalCentral:button.approve')}</span>
                        </Button>}
                        {isActionButtonShown && !data.request.isAzur && !storage.getAllowConsultation() && !isNullOrEmpty(denyTitle) && <Button startIcon={<CancelIcon />} variant="contained" color="secondary" size="small" className={`${styles.buttonStyle} ${(isActive || !isDenyButtonEnabled) ? styles.buttonDisabled : ""}`} style={{ backgroundColor: '#ef4444' }} onClick={(event) => handleRequest(event, data, actionType.DENY)}>
                            <span className={styles.buttonSpanStyle}>{denyTitle}</span>
                        </Button>}
                        <Button startIcon={<InfoIcon />} variant="contained" disabled={isActive} size="small" className={`${styles.buttonStyle} ${isActive ? styles.buttonDisabled : ""}`} style={{ backgroundColor: '#e5e7eb' }} onClick={() => handleClick(data)}>
                            <span className={styles.buttonSpanStyle}>{i18next.t('approvalCentral:button.detail')}</span>
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        );
    };

    return (
        <LoadingLayer isActive={isActive}>
            <div id="divListRequest" data-type={props.type} className={styles.konekCard + ' ' + classes.divListRequest}>
                {data != null && data.map((obj, index) =>
                    <CentralApprovalCard key={index} data={obj} />
                )}

                {/*{isActive && <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px", zIndex:9999999999999 }} spin />}*/}
                {dataRow != null && <RequestDetail pageSource={pageSourceCode.APPROVAL_CENTRAL}
                    open={open}
                    data={dataRow}
                    comment={comment}
                    setComment={setComment}
                    load={loadPage}
                    isPosting={isActive}
                    setIsPosting={setIsActive}
                    onClose={handleClose}
                    handleRequest={handleRequest}
                    getIsLeaveRequest={getIsLeaveRequest}
                    getIsActionButtonShown={getIsActionButtonShown}
                    getIsDenyButtonEnabled={getIsDenyButtonEnabled}
                    getIsApproveButtonEnabled={getIsApproveButtonEnabled}
                />}
                {dataRow?.centralApprovalId > 0 && dataRow?.originTableNameId > 0 && openCommentForm && <DenyWithCommitRequestForm open={openCommentForm} setOpen={setOpenCommentForm} centralApprovalId={dataRow.centralApprovalId} requestId={dataRow.originTableNameId} load={loadData} />}
                {openScheduleGeneration && <ScheduleGenerationForm open={openScheduleGeneration} setOpen={setOpenScheduleGeneration} employeeCode={dataRow.employeeCode} startDate={dataRow.startDate} endDate={dataRow.endDate} load={loadData} />}

                <Dialog
                    open={openConfirm}
                    onClose={() => { handleCloseConfirm() }}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">
                        {!isConfirm ? i18next.t('approvalCentral:dialog.attention') : i18next.t('approvalCentral:dialog.title')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {messageConfirm}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {isConfirm && dataRow?.centralApprovalId > 0 &&
                            <Button autoFocus onClick={updateAction} color="primary" className={styles.defaultButton} variant="contained">
                                {i18next.t('buttons:yes')}
                            </Button>}
                        {isConfirm && dataRow?.centralApprovalId > 0 &&
                            <Button onClick={() => { handleCloseConfirm(false, false) }} color="primary" className={styles.defaultButton} variant="contained">
                                {i18next.t('buttons:no')}
                            </Button>}
                        {!isConfirm && <Button onClick={() => { handleCloseConfirm() }} color="primary" className={styles.defaultButton} variant="contained">
                            {i18next.t('buttons:close')}
                        </Button>}
                    </DialogActions>
                </Dialog>
            </div>
        </LoadingLayer>
    );
}

export default withNamespaces(['approvalCentral', 'common', 'buttons', 'error', 'bankBalance'], { wait: true })(ListRequestItems);

ListRequestItems.propTypes = {
    filter: PropTypes.object.isRequired
}